import React from 'react';
import PropTypes from 'prop-types';

class NumberFormatInt extends React.Component {
    static propTypes = {
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.bool])
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.value !== this.props.value;
    }

    render() {
        if (this.props.value) {
            return <div style={{textAlign: 'right'}}
                        title={this.props.value}>{Number(this.props.value || 0).toString()}</div>;
        }
        return <div style={{textAlign: 'right'}}
                    title={this.props.value}>{this.props.value}</div>;

    }
}

export default NumberFormatInt;